module.exports = __webpack_public_path__ + "img/logo.cdabd073.svg";